// extracted by mini-css-extract-plugin
export default {"ClientNotes":"HLG7KXjs","InputWrapper":"CDkOKe8u","InputField":"hbzhu8Zo","EditBtn":"d3ylezxB"};